import { Component, OnInit } from '@angular/core';
import { Subject, takeUntil } from "rxjs";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { MenuService } from "../../../services/menus/menu.service";
import { MessageService } from "primeng/api";

@Component({
  selector: 'app-delete-menu',
  templateUrl: './delete-menu.component.html',
  styleUrls: ['./delete-menu.component.scss']
})
export class DeleteMenuComponent implements OnInit {

  //#region Fields
  public menuId: string;
  public spinner: boolean = false;
  public unsubscribe: Subject<void> = new Subject<void>();
  //#endregion

  //#region Constructor
  constructor(private config: DynamicDialogConfig,
              private ref: DynamicDialogRef,
              private menuService: MenuService,
              private messageService: MessageService) {
    if (this.config.data != undefined && this.config.data.id) {
      this.menuId = this.config.data.id;
    }
  }

  ngOnInit(): void {
  }
  //#endregion

  //#region Public Methods
  deleteMenu(menuId: string) {
    this.spinner = true;
    this.menuService.deleteMenu(menuId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.ref.close(true);
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
        }
      });
  }

  cancel(): void {
    this.ref.close(false);
  }
  //#endregion
}
